import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { HeaderActions } from "./HeaderActions";

export type WorkflowLayoutProps = {
	userMenu: ReactNode;
	headerActionButtons?: ReactNode;
	title?: string | ReactNode;
	subHeader?: ReactNode;
	contentClassName?: string;
	children?: ReactNode;
	toolbar?: ReactNode;
};

export const WorkflowLayout = (props: WorkflowLayoutProps) => {
	const { title, subHeader, contentClassName, children, toolbar } = props;
	return (
		<div className="w-full h-full flex flex-col" data-debug-id="WorkflowLayout">
			<div className="w-full flex items-center border border-b-bc-subtle text-[12.85px] text-secondary font-[450] px-8 pt-4 pb-5">
				<div className="flex-1 truncate">{title}</div>
				{props.userMenu && (
					<HeaderActions userMenu={props.userMenu} actionButtons={props.headerActionButtons} />
				)}
			</div>
			{subHeader}
			<div className="w-full flex-1 flex min-h-0">
				<div className={cn("w-full flex-1 flex justify-center", contentClassName)}>{children}</div>
				<div>{toolbar}</div>
			</div>
		</div>
	);
};
